var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-left":"325px"}},[_c('v-img',{staticStyle:{"width":"75%"},attrs:{"src":"/graph"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }